import { MotionValue, useTransform } from "motion/react";
import { interpolate } from "flubber";

export function useFlubber(
  pathIndexProgress: MotionValue<number>,
  paths: string[]
): MotionValue<string> {
  return useTransform(
    pathIndexProgress,
    paths.map((_: string, index: number) => index), // input keyframes
    paths, // output keyframes
    {
      // mixer will be called with each pair of output values and must return a new function,
      // that accepts a progress value between 0 and 1 and returns the mixed value.
      mixer: (a, b) => interpolate(a, b, { maxSegmentLength: 0.1 })
      // clamp: true
    }
  );
}
